import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, Row, Col, Typography, message, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import EmployeeService from '../../service/employee-service/Employee.service';
import { DetailedEmployeeResponse } from '../../model/Employee.model';
import BasicInfo from '../../component/employee/detail/BasicInfo';
import AccountBalance from '../../component/employee/detail/AccountBalance';
import FundHistory from '../../component/employee/detail/FundHistory';
import TransferHistory from '../../component/employee/detail/TransferHistory';

const { Text } = Typography;

const EmployeeDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState<DetailedEmployeeResponse | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(false);

  const fetchEmployee = useCallback(async () => {
    setLoading(true);
    try {
      const data = await EmployeeService.getEmployeeById(Number(id));
      setEmployee(data);
    } catch (error) {
      console.error('Error fetching employee details:', error);
      message.error('Error fetching employee details. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchEmployee();
  }, [fetchEmployee]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-4">
        <Spin size="large" />
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="text-center py-4">
        <Text>No data available.</Text>
      </div>
    );
  }

  // Kiểm tra nếu là admin (ID = 1) thì không hiển thị các bảng quỹ
  const isAdmin = employee.id === 1;

  return (
    <div className="p-4">
      <Row gutter={[16, 16]}>
        <Col span={2}>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            className="mb-4"
          >
            Quay lại
          </Button>
        </Col>
        <Col span={21}></Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <BasicInfo employee={employee} refreshData={fetchEmployee} />
        </Col>
        <Col span={24}>
          <AccountBalance employeeId={employee.id} />
        </Col>
      </Row>

      {/* Chỉ hiển thị các bảng quỹ nếu không phải admin */}
      {!isAdmin && (
        <>
          <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
            <Col span={24}>
              <FundHistory employeeId={employee.id} />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
            <Col span={24}>
              <TransferHistory employeeId={employee.id} />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default EmployeeDetail;
